module.exports = __webpack_public_path__ + "static/email-template-trial-ended-doggify-16bbaf7ef2a0c699915c25e8ad265c3e.png";